export default __webpack_public_path__ + "b9be6f7.png";